<template>
  <Dropdown
    v-model="language"
    :options="languages"
    optionLabel="label"
    optionValue="value"
    data-test="select-language"
    :placeholder="$t(`constants.languages.${language}`)"
    :size="size"
    :class="{ 'w-full': w_full }"
    @update:modelValue="(value) => $emit('input', value)"
  >
    <template #option="slotProps">
      <p :data-test="`select-language-${slotProps.option.value}`">{{ slotProps.option.label }}</p>
    </template>
  </Dropdown>
</template>

<script>
import { LANGUAGES_CONTENT } from '@/app/data/model_constants';

export default {
  name: 'SelectLanguage',
  props: {
    disabled: { type: Boolean, default: false },
    horizontal: { type: Boolean },
    is_customer: { type: Boolean, default: false },
    is_read_only: { type: Boolean, default: false },
    language_prop: { type: String, required: true },
    message: { type: String, default: null },
    hide_label: { type: Boolean },
    expanded: { type: Boolean, default: true },
    size: { type: String, default: 'small' },
    custom_style: { type: String, default: '' },
    w_full: { type: Boolean, default: false },
  },

  emits: ['input'],

  data() {
    return { language: '' };
  },

  computed: {
    readOnlyLanguage() {
      return this.$t(`constants.languages.${this.language}`);
    },

    languages() {
      return LANGUAGES_CONTENT.map((lang) => ({
        label: this.$t(`constants.languages.${lang}`),
        value: lang,
      }));
    },
  },

  watch: {
    language_prop(newValue) {
      this.language = newValue;
    },
  },

  mounted() {
    this.language = this.language_prop || this.$i18n.locale;
  },
};
</script>
